import { createRipples } from './createRipples';
import withAttrs from './withAttrs';
export default withAttrs(createRipples());
export * from './createRipples';